// Color estable por profesor (misma paleta en vista mes y semana).
export const TEACHER_PALETTE = [
  "bg-sky-100 text-sky-900 border-sky-300",
  "bg-emerald-100 text-emerald-900 border-emerald-300",
  "bg-amber-100 text-amber-900 border-amber-300",
  "bg-purple-100 text-purple-900 border-purple-300",
  "bg-pink-100 text-pink-900 border-pink-300",
  "bg-cyan-100 text-cyan-900 border-cyan-300",
  "bg-orange-100 text-orange-900 border-orange-300",
  "bg-lime-100 text-lime-900 border-lime-300",
  "bg-rose-100 text-rose-900 border-rose-300",
  "bg-indigo-100 text-indigo-900 border-indigo-300",
];

export const colorForTeacher = (teachers, teacherId) => {
  const idx = (teachers || []).findIndex((t) => t.id === teacherId);
  if (idx >= 0) return TEACHER_PALETTE[idx % TEACHER_PALETTE.length];
  return "bg-slate-100 text-slate-700 border-slate-300";
};

export const matchesTeacher = (e, teacherFilter) =>
  teacherFilter === "all" || (e.teacher_id || "") === teacherFilter;
